import { render, staticRenderFns } from "./ArchiInfo.vue?vue&type=template&id=74e83ce6&scoped=true"
import script from "./ArchiInfo.vue?vue&type=script&lang=js"
export * from "./ArchiInfo.vue?vue&type=script&lang=js"
import style0 from "./ArchiInfo.vue?vue&type=style&index=0&id=74e83ce6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e83ce6",
  null
  
)

export default component.exports